

















































































import axios from "axios";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import List from "./List.vue";
import NewList from "./NewList.vue";
import MyForm from "../MyForm";
import {ListModel, RootObjectModel, initializedRootObjectModel} from '../Interfaces/TodoModel';


@Component({
    components: {
        List,
        NewList
    }
})
export default class Todo extends Vue {
    private todo: RootObjectModel = initializedRootObjectModel

    private form = new MyForm();

    @Prop() readonly todoId!: number;
    $store: any;

    created() {
        this.getTodo();
    }

    get singleView(): boolean {
        return this.$store.state.todos.todosLoaded;
    }

    set singleView(newVal: boolean) {
        this.$store.state.todos.todosLoaded = newVal;
    }

    get addingEnabled(): boolean {
        return this.$store.state.todoList.addingEnabled;
    }

    set addingEnabled(newVal: boolean) {
        this.$store.state.todoList.addingEnabled = newVal;
    }

    get editingEnabled(): boolean {
        return this.$store.state.todoList.editingEnabled;
    }

    set editingEnabled(newVal: boolean) {
        this.$store.state.todoList.editingEnabled = newVal;
    }

    get completed(): Array<ListModel> {
        return this.todo.lists.filter(list => list.isCompleted);
    }

    get inComplete(): Array<ListModel> {
        return this.todo.lists.filter(list => !list.isCompleted);
    }

    get achievement(): number {

        const num = (this.completed.length / this.todo.lists.length) * 100;

        return isNaN(num)  ? 0 :  Math.round(num * 100 + Number.EPSILON) / 100;
    }

    @Watch("todoId")
    async getTodo() {
      await  axios.get(`/api/todos/${this.todoId}`).then(({ data }) => {
            this.todo = data;

            this.form = new MyForm({
                title: this.todo.title,
                description: this.todo.description
            });
        });
    }

    updateTodo(){
        axios.patch(`/api/todos/${this.todo.id}`, this.form)
        .then(({data}) => {
            this.todo = data
        })
        .catch(error => {
            this.form.error = error.response.data.errors
        })
    }

    deleteTodo(){
     const confirmed: boolean = confirm(`You are about to delete this todo and its list as  whole,
     Are you Sure about this ?`) 
       if(confirmed) {
           axios.delete(`/api/todos/${this.todo.id}`)
        .then(() => {
            window.location.pathname = '/todos';
        }).catch(response => {
        console.log(response)
        })
       }
    }

    pushList(data: ListModel): void {
        this.todo.lists.push(data);
    }
}
